import { SiteWhatsAppFab } from '@/components/site/SiteWhatsAppFab';
import { SiteHeader } from './sections/SiteHeader';
import { SiteHero, SiteTrustBar } from './sections/SiteHero';
import { SitePains } from './sections/SitePains';
import { SiteHowItWorks } from './sections/SiteHowItWorks';
import { SiteMechanismProof } from './sections/SiteMechanismProof';
import { SiteFeatures } from './sections/SiteFeatures';
import { SiteAutopilot } from './sections/SiteAutopilot';
import { SiteSegments } from './sections/SiteSegments';
import { SiteNetwork } from './sections/SiteNetwork';
import { SiteImplantacao } from './sections/SiteImplantacao';
import { SitePricing } from './sections/SitePricing';
import { SiteFAQ } from './sections/SiteFAQ';
import { SiteCtaFinal } from './sections/SiteCtaFinal';
import { SiteFooter } from './sections/SiteFooter';

export function LandingPage() {
  return (
    <div className="site-public min-h-screen">
      <SiteHeader />
      <main>
        <SiteHero />
        <SiteTrustBar />
        <SitePains />
        <SiteHowItWorks />
        <SiteMechanismProof />
        <SiteFeatures />
        <SiteAutopilot />
        <SiteSegments />
        <SiteNetwork />
        <SiteImplantacao />
        <SitePricing />
        <SiteFAQ />
        <SiteCtaFinal />
      </main>
      <SiteFooter />
      <SiteWhatsAppFab />
    </div>
  );
}
